/**
 * Нужно ли показать экран согласия (LegalConsentGate) вместо главного меню.
 *
 * Обязательных согласий три: лицензионное соглашение, политика
 * конфиденциальности и подтверждение того, что пользователю исполнилось 18
 * лет. Не хватает любого — экран держится. Поэтому и те, кто принял документы
 * до появления подтверждения возраста, увидят его один раз.
 *
 * Гость согласий не дает (соглашаться от имени несуществующего аккаунта не с
 * чем): флаги в его моковом профиле заранее true, а экран появится сразу после
 * настоящего входа (см. GUEST_PROFILE)
 *
 * @param {Object} auth — state.private.auth
 * @returns {boolean}
 */
export const checkIfLegalConsentRequired = (auth) => !auth?.hasAcceptedPrivacyPolicy
  || !auth?.hasAcceptedLicenseAgreement
  || !auth?.hasConfirmedAdult;
